import { useEffect, useState } from 'react';
import '/assets/styles/pages/home.scss';

// Sections
import BranchInfo from '/views/sections/branch-info';
import HomeProductBanners from '/views/sections/home-product-banners';
import HomeLotteryInfo from '/views/sections/home-lottery-info';
import HomeCategories from '/views/sections/home-categories';
import ActiveOrderList from '/views/sections/active-order-list';
// import HomeHighlightedProducts from '/views/sections/home-highlighted-products';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useMenu } from '/utilities/menu';

// Services
import siteServices from '/services/site';
import menuServices from '/services/menu';

const getBanners = (selectedBranch) => siteServices.getBanners(selectedBranch?.id ?? 0);

const getCategories = (selectedBranch) => menuServices.getMenu(selectedBranch?.slug).then((menu) => menu.categories);

const getHighlightedProducts = () => siteServices.getHighlightedProducts();

const Homepage = ({ pageProps }) => {
	const { selectedBranch } = useBranchSelection();
	const { loadMenu } = useMenu();

	const [banners, setBanners] = useState(pageProps?.banners);
	const [categories, setCategories] = useState(pageProps?.categories);
	const [highlightedProducts, setHighlightedProducts] = useState(pageProps?.products);

	useEffect(() => {
		if (!banners || banners.branchId !== (selectedBranch?.id ?? 0)) {
			getBanners(selectedBranch)
				.then((newBanners) => {
					setBanners({
						branchId: selectedBranch?.id ?? 0,
						banners: newBanners,
					});
				})
				.catch(() => {
					setBanners(false);
				});
		}
	}, [banners, selectedBranch]);

	useEffect(() => {
		if (selectedBranch && categories?.branchSlug !== selectedBranch.slug) {
			loadMenu(selectedBranch.slug)
				.then(({ categories: newCategories }) => {
					setCategories({
						branchSlug: selectedBranch.slug,
						categories: newCategories,
					});
				})
				.catch(() => {
					setCategories(false);
				});
		}
	}, [categories, selectedBranch]);

	useEffect(() => {
		if (highlightedProducts === undefined) {
			getHighlightedProducts()
				.then(setHighlightedProducts)
				.catch(() => {
					setHighlightedProducts(false);
				});
		}
	}, [highlightedProducts]);

	return (
		<>
			<BranchInfo />
			<HomeLotteryInfo />
			{banners !== false && <HomeProductBanners data={banners?.banners} />}
			<ActiveOrderList />
			{categories !== false && <HomeCategories data={categories} />}
			{/* {highlightedProducts !== false && <HomeHighlightedProducts data={highlightedProducts} />} */}
		</>
	);
};

Homepage.getServerProps = () => {
	return new Promise((resolve) => {
		Promise.all([getBanners(), getCategories(), getHighlightedProducts()])
			.then(([banners, categories, products]) => {
				resolve({
					pageProps: {
						banners,
						categories,
						products,
					},
				});
			})
			.catch(() => {
				resolve({
					pageProps: {},
				});
			});
	});
};

export default Homepage;
